import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-simple-loader',
  templateUrl: './simple-loader.component.html',
  styleUrls: ['./simple-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleLoaderComponent {}
